/* eslint-disable max-classes-per-file */
import { TenantContext } from '../lib'

/**
 * Sets the active tenant context. Dispatched from the handful of places that already
 * decide "which court/organization/individual is current" (see `TenantState` doc
 * comment for the full list) - not intended to be dispatched directly from pages or
 * components.
 */
export class SetTenantContextAction {
  static readonly type = '[Tenant] Set Tenant Context'

  constructor(public tenantContext: TenantContext) {}
}

/**
 * Resets tenant context back to not-asked, i.e. "no tenant context" rather than the `None`
 * tenant type (a logged-in user with no court/org/individual workspace). Dispatched on full
 * sign-out, when exiting an organization, and when an individual tenant was expected but no
 * individual id is available, so a previously chosen tenant is not left in place.
 */
export class ResetTenantContextAction {
  static readonly type = '[Tenant] Reset Tenant Context'
}
